import React from "react";
import "../Styles/about.css";

/* Image path */
const handshakeImg = "/images/handshake.jpg";

/* Feature cards using image icons */
const features = [
  {
    icon: "/assets/about_icon_1.png",
    title: "Industry Network",
    desc: "Connect with HR leaders, CXOs, and decision-makers across industries.",
  },
  {
    icon: "/assets/about_icon_2.png",
    title: "Brand Recognition",
    desc: "Increase your organization's visibility through premium HR platforms and events.",
  },
  {
    icon: "/assets/about_icon_3.png",
    title: "Knowledge Exchange",
    desc: "Share insights, showcase expertise, and establish thought leadership.",
  },
  {
    icon: "/assets/about_icon_4.png",
    title: "Talent Connect",
    desc: "Engage with universities, professionals, and the next generation of talent.",
  },
];

const brandPoints = [
  {
    title: "Leadership Branding",
    desc: "Position your brand as a trusted HR thought leader.",
  },
  {
    title: "Business Visibility",
    desc: "Increase brand awareness among HR professionals and industry leaders",
  },
  {
    title: "Community Engagement",
    desc: "Build meaningful relationships through exclusive HR events and communities.",
  },
  {
    title: "Future Workforce Access",
    desc: "Connect with academic institutions and emerging talent to build tomorrow's workforce.",
  },
];

export default function About() {
  return (
    <div className="about-page">

      {/* ================= SECTION 1 ================= */}
      <section className="aboutpage-section aboutpage-section--one">
        <div className="about-container about-row">

          {/* LEFT CONTENT */}
          <div className="about-col about-col--left">

            <h2 className="aboutpage-heading">
              Building the Future of HR Through Community,
              Leadership &amp; Innovation
            </h2>

            <p className="aboutpage-text">
              Vanakkam HRD is one of India's fastest-growing HR communities,
              dedicated to bringing together HR leaders, business executives,
              people managers, academicians, and industry experts on a single
              platform. We create meaningful opportunities for learning,
              networking, collaboration, and professional growth through
              conferences, leadership summits, knowledge forums, awards, and
              community initiatives.
            </p>

            <p className="aboutpage-text">
              Our mission is to strengthen the HR ecosystem by fostering thought
              leadership, celebrating excellence, and enabling organizations to
              stay ahead in the ever-evolving world of work. By connecting
              industry and academia, showcasing innovative HR practices, and
              creating powerful networking experiences, we empower professionals
              and organizations to build future-ready workplaces.
            </p>

            <p className="aboutpage-text">
              At Vanakkam HRD, we don't just organize events—we build
              relationships, inspire leaders, and create communities that shape
              the future of Human Resources.
            </p>

          </div>


          {/* RIGHT FEATURE PANEL */}
          <div className="about-col about-col--right">

            <div className="feature-panel">

              <h3 className="feature-heading">
                Build Your HR Presence
              </h3>


              <div className="feature-grid">

                {features.map((f) => (
                  <div className="about-feature-card" key={f.title}>

                    <div className="feature-icon-box">
                      <img
                        src={f.icon}
                        alt={f.title}
                        className="about-feature-icon"
                      />
                    </div>


                    <h4 className="feature-title">
                      {f.title}
                    </h4>


                    <p className="feature-desc">
                      {f.desc}
                    </p>

                  </div>
                ))}

              </div>

            </div>

          </div>

        </div>
      </section>


      {/* ================= SECTION 2 ================= */}
      <section className="aboutpage-section aboutpage-section--two">

        {/*
          Flattened on purpose: heading, image, subtext and the card list are
          now direct siblings inside "brand-grid". This lets CSS reorder them
          independently per breakpoint (mobile = heading -> image -> subtext
          -> cards, stacked in that exact order; desktop = image on the left
          with heading/subtext/cards stacked on the right) without touching
          the markup again.
        */}
        <div className="about-container brand-grid">

          <h3 className="brand-heading">
            Empowering Brands Through HR Communities
          </h3>

          <div className="brand-image-wrap">
            <img
              src="/assets/About_image.png"
              alt="Business professionals shaking hands"
              className="brand-image"
            />
          </div>

          <p className="brand-subtext">
            Vanakkam HRD connects organizations with India's leading HR professionals through high-impact events, leadership forums, and community-driven initiatives that foster visibility, credibility, and lasting business relationships.
          </p>

          <div className="brand-card-list">

            {brandPoints.map((b) => (

              <div className="brand-card" key={b.title}>

                <p className="brand-card-text">

                  <span className="brand-card-title">
                    {b.title}
                  </span>

                  {" – "}

                  {b.desc}

                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

    </div>
  );
}